// 
// -----------------------------------------------------------------------------
(function ($carousel) {
	if ($carousel.length === 0) {return false;}

        var listItems = $carousel.children('li'),
        listLen = listItems.length,
        i = 0,
        changeList = function () {
            listItems.eq(i).fadeOut(300, function () {
                i += 1;
                if (i === listLen) {
                    i = 0;
                }
                listItems.eq(i).fadeIn(300);
            });
        };
    listItems.not(':first').hide();
    $carousel.animate({'opacity': 1},600);
    setInterval(changeList, 5000);


})($( '#carousel' ));